import React from 'react';

const CheckCheckIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
         height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
         stroke={props.stroke ? props.stroke : 'currentColor'}
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    >
        <path d="M18 6 7 17l-5-5"/>
        <path d="m22 10-7.5 7.5L13 16"/>
    </svg>
);

export default CheckCheckIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/CheckCheckIcon.jsx